import type { FC } from 'react';
import { useEffect, useState } from 'react';
import type { HEX, HSVA } from '../../types';
import { ColorEnum } from '../../types';
import { isCompleteHex } from '../../util/hue_helper';
import { ColorModel } from '../../colorModel';

import './style.less';

interface HexInputInterface {
  hsva: HSVA;
  onChange: (hsva: HSVA) => void;
}

export const HexInput: FC<HexInputInterface> = (props) => {
  const { hsva, onChange } = props;
  const [hex, setHex] = useState<HEX>(ColorModel.toColorSet(hsva)[ColorEnum.HEX]);
  const [isFocus, setIsFocus] = useState<boolean>(false);

  useEffect(() => {
    if (isFocus) return;
    setHex(ColorModel.toColorSet(hsva)[ColorEnum.HEX]);
  }, [hsva]);

  const handleHexChange = (hex: HEX) => {
    // Only propagate the change when the user has typed a complete 6- or 8-digit hex
    // code. Shorter inputs (including 3-digit shorthand) are stored locally so the
    // field shows what is being typed without applying an intermediate colour.
    if (isCompleteHex(hex)) {
      onChange(ColorModel.toColorSet(hex).hsv);
    }
    setHex(hex);
  };

  const handleOnBlur = () => {
    // Commit the value the user actually typed if it is a complete valid hex.
    // Fall back to re-deriving from the current hsva state when the field was left
    // with an incomplete or invalid value.
    if (isCompleteHex(hex)) {
      onChange(ColorModel.toColorSet(hex).hsv);
    } else {
      setHex(ColorModel.toColorSet(hsva)[ColorEnum.HEX]);
    }
    setIsFocus(false);
  };

  const getHexWithoutHash = (hex: HEX) => {
    if (hex.startsWith('#')) {
      return hex.slice(1);
    }
    return hex;
  };

  return (
    <div className="input-hex">
      <input
        value={getHexWithoutHash(hex)}
        onChange={(e) => handleHexChange(e.target.value)}
        onFocus={() => setIsFocus(true)}
        onBlur={handleOnBlur}
      />
      <span>Hex</span>
    </div>
  );
};
